export enum DepositCategoryTypeEnum {
  Local_Service = 1,
  Professional_Service = 2,
  International_Service = 3,
}

export enum DepositStatusEnum {
  Active = 1,
  Inactive = 2,
}

export enum DepositRuleTypeEnum {
  Fixed_Amount = 1,
  Percentage = 2,
}

